import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import deFlag from "../images/de-flag.svg";
import gbFlag from "../images/gb-flag.svg";
import deFlagHover from "../images/de-flag-hover.gif";
import gbFlagHover from "../images/gb-flag-hover.gif";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [hovered, setHovered] = useState(null);

  const flags = [
    { code: "de", default: deFlag, hover: deFlagHover, alt: "DE Flag" },
    { code: "gb", default: gbFlag, hover: gbFlagHover, alt: "EN Flag" },
  ];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="language-buttons">
      {flags.map((flag) => (
        <img
          key={flag.code}
          src={hovered === flag.code ? flag.hover : flag.default}
          className="flag"
          alt={flag.alt}
          onMouseEnter={() => setHovered(flag.code)}
          onMouseLeave={() => setHovered(null)}
          onClick={() => changeLanguage(flag.code)}
        />
      ))}
    </div>
  );
};

export default LanguageSwitcher;
